import { Component, Inject, Input, Optional } from '@angular/core';
import { CdkStep, CdkStepper } from '@angular/cdk/stepper';

@Component({
  selector: 'mui-wizard-stepper',
  styles: [':host { display: block; }', '.linear {pointer-events: none; user-select: none}'],
  templateUrl: './mui-wizard-stepper.component.html'
})
export class MuiWizardStepper {
  @Input()
  set wizard(wiz: CdkStepper | undefined) {
    this._wizard = wiz;
  }

  get wizard(): CdkStepper | undefined {
    return this._wizard;
  }

  get linear(): boolean | null {
    return this._wizard?.linear ?? null;
  }

  constructor(@Optional() @Inject(CdkStepper) private _wizard?: CdkStepper) {}

  /**
   * If this.linear is false user will be able to click on the step
   * if this.linear is true use will not be able to click on the step
   * @param currentStep
   * @param $event
   */
  selectStep(currentStep: CdkStep, $event: Event): void {
    $event.preventDefault();

    if (!this.linear) {
      currentStep.select();
    }
  }

  protected focusNextStep($event: KeyboardEvent): void {
    $event.preventDefault();
    const element = $event.target as HTMLLIElement;
    const sibling = element.nextElementSibling as HTMLLIElement;
    if (sibling) {
      sibling.focus();
    }
  }

  protected focusPrevStep($event: KeyboardEvent): void {
    $event.preventDefault();
    const element = $event.target as HTMLLIElement;
    const sibling = element.previousElementSibling as HTMLLIElement;
    if (sibling) {
      sibling.focus();
    }
  }
}
